import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

import { CertificateType, SimpleAuthCertificateType, SimpleAuthCredentialType, SimpleAuthFromType, SimpleAuthUserIdentityType } from '@/lib/types/simple-auth';

export const tinAtom = atom<string>('');
export const certTypeAtom = atom<CertificateType>('kakao');

export const simpleAuthFromTypeAtom = atom<SimpleAuthFromType>('lookup');
export const simpleAuthCertTypeAtom = atomWithStorage<SimpleAuthCertificateType>(
  'refund_simple-auth_cert-type',
  'kakao',
  createJSONStorage(() => sessionStorage)
);
export const simpleAuthCredentialAtom = atom<SimpleAuthCredentialType | null>(null);
export const simpleAuthUserIdentityAtom = atom<SimpleAuthUserIdentityType | null>(null);

/**
 * 간편인증 로직 이후 발급되는 token. 이후 수집 로직에서 람다 실행시킬때 필요
 * */
export const refundTokenAtom = atomWithStorage<string | null>(
  'bznav_refund-token',
  null,
  createJSONStorage(() => sessionStorage)
);
